import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import s from './index.module.scss';

const FILE_FORMATS = ['pdf', 'xlsx', 'csv'];

export const FileFormatPicker = ({ value, onChange }) => {
  const { t } = useTranslation('reports');
  return (
    <div className={s.wrapper}>
      <div className="f-small-accent">{t('format_picker.format')}</div>
      <div className={s.items}>
        {FILE_FORMATS.map(format => (
          <div
            className={classnames(s.item, value === format && s.item_active)}
            key={format}
            onClick={() => onChange(format)}
          >
            {format}
          </div>
        ))}
      </div>
    </div>
  );
};
